export default "__VITE_ASSET__WJEdngXb__"